export const showSuggestedProductsBeforeSFLSelectorFn = (isSuggestedProductEmpty, isSavedForLaterListEmpty, isCartEmpty) => {
  return !isSuggestedProductEmpty && isSavedForLaterListEmpty && !isCartEmpty;
};
export const showSuggestedProductsAfterSFLSelectorFn = (isSuggestedProductEmpty, isSavedForLaterListEmpty, isCartEmpty) => {
  return !isSuggestedProductEmpty && !isSavedForLaterListEmpty && !isCartEmpty;
};